import { useQuery } from '@tanstack/react-query';
import { getAccount } from './api/personal.js';

export const ACCOUNT_KEY = ['account'] as const;

export function useAccount() {
  return useQuery({ queryKey: ACCOUNT_KEY, queryFn: getAccount, staleTime: 60_000 });
}
